import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialog-content gutter-y-s3" }
const _hoisted_2 = { class: "text-muted mb-s2" }
const _hoisted_3 = { class: "flex dialog-detail align-items-center justify-content-between" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "dialog-footer dialog-footer-two-btn" }

import Spinner from '@/components/Spinner.vue';
import TokenIcon from '@/components/token/TokenIcon.vue';
import { useI18n } from 'vue-i18n';
import { format, printUSD } from '@/utils/format';
import { Token } from '@/sdk/entities/token';
import InfoMessage from '@/components/InfoMessage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HarvestConfirmation',
  props: {
    earned: null,
    earnedUsd: null,
    cancel: null,
    confirm: null,
    inProgress: { type: Boolean },
    isSyrup: { type: Boolean },
    token: null,
    isNotAvailable: { type: Boolean },
    minAmountForFee: null
  },
  setup(__props: any) {

const props = __props as {
  earned: string | number;
  earnedUsd: string | number;
  cancel: () => void;
  confirm: () => void;
  inProgress?: boolean;
  isSyrup?: boolean;
  token: Token;
  isNotAvailable?: boolean;
  minAmountForFee?: string | number | null;
}


const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('farming.harvestConfirmDialog.earnings')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(TokenIcon, {
            "icon-src": __props.token.tokenIconUrl,
            symbol: __props.token.symbol,
            size: "20",
            full: ""
          }, null, 8, ["icon-src", "symbol"]),
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_unref(format)(__props.earned)), 1),
            _createElementVNode("span", _hoisted_4, " / " + _toDisplayString(_unref(printUSD)(__props.earnedUsd)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        (__props.isNotAvailable)
          ? (_openBlock(), _createBlock(InfoMessage, {
              key: 0,
              type: "error",
              "as-panel": ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('farming.harvestConfirmDialog.notEnoughCurrencyForFee', {
            amount: __props.minAmountForFee,
            symbol: 'ADA',
          })), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Button, {
        class: "button-base",
        label: _unref(t)('cancel'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.cancel()))
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        class: "button-primary",
        label: _unref(t)('farming.harvestConfirmDialog.confirmBtn'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.confirm())),
        disabled: !!(__props.inProgress || __props.isNotAvailable)
      }, {
        default: _withCtx(() => [
          (__props.inProgress)
            ? (_openBlock(), _createBlock(Spinner, {
                key: 0,
                color: "white",
                size: "24",
                class: "mr-s2"
              }))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_unref(t)('farming.harvestConfirmDialog.confirmBtn')), 1)
        ]),
        _: 1
      }, 8, ["label", "disabled"])
    ])
  ], 64))
}
}

})